module.exports = __webpack_public_path__ + "img/mulogo.2ebb6d47.png";